import { collection, getDocs } from "firebase/firestore";
import { fbGetMembers } from "../firebaseService/endPoints/admin/members";
import { db } from "../firebaseService/connection";
import useGlobalStore from "../../store/store";

export const fetchMembers = async (groupId) => {
  if (!groupId) {
    return;
  }

  const { setMembersList, setMembersLoading } =
    useGlobalStore.getState().members;

  setMembersLoading(true); // Set loading to true immediately

  return fbGetMembers(groupId)
    .then(async (members) => {
      // Map members data

      members = members.map((contents, index) => {
        let memberName = "N/A";

        if (
          contents?.firstName &&
          contents?.lastName &&
          contents?.lastName?.length > 0 &&
          contents?.firstName?.length > 0
        ) {
          memberName = `${contents.firstName} ${contents.lastName}`;
        } else if (contents?.firstName && contents?.firstName?.length > 0) {
          memberName = contents.firstName;
        } else if (contents?.name && contents?.name?.length > 0) {
          memberName = contents?.name;
        } else if (contents?.fullName && contents?.fullName?.length > 0) {
          memberName = contents?.fullName;
        }

        return {
          ...contents,
          pageId: index,
          joinedChant: contents.hideGroup ? "No" : "Yes",
          name: memberName,
          lockStatus: contents.lockStatus || false,
          address: contents.address1 || contents.address,
          fullName: memberName,
          tshirtSize: contents.tshirtSize || contents["t-shirtSize"],
          registrationDate: contents.registeredOnChantDate,
          joinedEmailList:
            contents.joinedEmailList === true
              ? "Yes"
              : contents.joinedEmailList === false
                ? "No"
                : "",
          shareVolunteerOpportunities:
            contents.shareVolunteerOpportunities === true
              ? "Yes"
              : contents.shareVolunteerOpportunities === false
                ? "No"
                : "",
        };
      });

      // Fetch unregistered users
      let unregisteredUsers = await getDocs(
        collection(db, "invite_emails", groupId, "userDetails")
      ).then((snap) => {
        let unregisteredMembers = [];
        let emailKeyMap = {};
        let userDetails = {};

        for (let doc of snap.docs) {
          if (doc.exists()) {
            let data = doc.data() || {};

            const memberIdx = members.findIndex(
              (member) => member.email === data?.email
            );

            if (memberIdx > -1) {
              members[memberIdx].registrationDate = data?.registeredOn;
            }

            if (!doc.userId) {
              userDetails[doc.id] = data;

              let email = (data.email ?? "").toLowerCase();
              if (!emailKeyMap[email]) {
                emailKeyMap[email] = doc.id;
              } else {
                if (
                  emailKeyMap[email] === email &&
                  doc.id.toLowerCase() !== email
                ) {
                  emailKeyMap[email] = doc.id;
                }
              }
            }
          }
        }
        unregisteredMembers = Object.values(emailKeyMap).map((key, index) => {
          let memberName = "N/A";
          let userDetail = userDetails[key];

          if (
            userDetail?.firstName &&
            userDetail?.lastName &&
            userDetail?.lastName?.length > 0 &&
            userDetail?.firstName?.length > 0
          ) {
            memberName = `${userDetail.firstName} ${userDetail.lastName}`;
          } else if (
            userDetail?.firstName &&
            userDetail?.firstName?.length > 0
          ) {
            memberName = userDetail.firstName;
          } else if (userDetail?.name && userDetail?.name?.length > 0) {
            memberName = userDetail?.name;
          } else if (userDetail?.fullName && userDetail?.fullName?.length > 0) {
            memberName = userDetail?.fullName;
          }

          return {
            ...userDetail,

            userRole: userDetail?.userRole,
            id: -1 * (index + 1),
            name: memberName,
            lockStatus: userDetail.lockStatus || false,
            registrationDate: userDetail.registeredOn,
            address: userDetail.address || userDetail.address1,
            registeredOnChantDate: "",
            fullName: memberName,
            tshirtSize: userDetail.tshirtSize || userDetail["t-shirtSize"],
            joinedEmailList:
              userDetail.joinedEmailList === true
                ? "Yes"
                : userDetail.joinedEmailList === false
                  ? "No"
                  : "",
            shareVolunteerOpportunities:
              userDetail.shareVolunteerOpportunities === true
                ? "Yes"
                : userDetail.shareVolunteerOpportunities === false
                  ? "No"
                  : "",
          };
        });
        return unregisteredMembers;
      });

      // Combine members and unregistered users
      let membersEmail = members.map((member) => member.email);
      unregisteredUsers.forEach((user) => {
        if (!membersEmail.includes(user.email)) {
          members.push({
            ...user,
            pageId: members.length,
            joinedChant: "No",
          });
        }
      });

      // Clean up members
      members.forEach((member) => {
        if (member.children && member.children.length === 0) {
          delete member.children;
        }
      });

      // Set the members list
      setMembersList(groupId, members);
    })
    .catch((error) => {
      console.error("Error fetching members:", error); // Log error for easier debugging
    })
    .finally(() => {
      setMembersLoading(false); // Always set loading to false
    });
};
